export default __webpack_public_path__ + "static/media/PersImg23.fe86698a.jpg";